import styled from 'styled-components';
import { lighten } from 'polished';
import { FlagProps } from './index';

interface ContainerProps {
  disabled: boolean;
  // type: string;
  // type:
  //   | 'indisponivel'
  //   | 'nao_autorizado'
  //   | 'sem_planilha'
  //   | 'inativo'
  //   | 'noclosedcaption'
  //   | 'exibrede'
  //   | 'fade'
  //   | 'semCC'
  //   | 'semweb'
  //   | 'NA'
  //   | 'arquivado'
  //   | 'autotranscrever'
  //   | 'pendente'
  //   | 'fila_download'
  //   | 'baixando'
  //   | 'emAndamento'
  //   | 'emprocesso'
  //   | 'processando'
  //   | 'avaliacao_eng'
  //   | 'fila_envio'
  //   | 'resetar_senha'
  //   | 'convertendo'
  //   | 'cadastrando'
  //   | 'enviando_exibidor'
  //   | 'enviadaVI'
  //   | 'analisando'
  //   | 'gravado'
  //   | 'conferido'
  //   | 'processado'
  //   | 'aprovado'
  //   | 'ingest_manual'
  //   | 'ativo'
  //   | 'convertido'
  //   | 'cadastrado'
  //   | 'closedcaption'
  //   | 'cadastrada'
  //   | 'encapsulada'
  //   | 'entregue'
  //   | 'editada'
  //   | 'finalizado'
  //   | 'analisado'
  //   | 'ressalva'
  //   | 'aprovacao'
  //   | 'reprovado_eng'
  //   | 'reprovado'
  //   | 'error'
  //   | 'erro'
  //   | 'erro_envio'
  //   | 'erroconversao'
  //   | 'errocadastro'
  //   | 'alteracao'
  //   | 'naogravado'
  //   | 'reenvio'
  //   | 'edicao'
  //   // Tipos de Comerciais
  //   | 'comercial'
  //   | 'base'
  //   | 'patrocinio'
  //   // Tipos de Chamadas
  //   | 'chamada'
  //   | 'vinheta'
  //   | 'promocional'
  //   | 'chpatrocinada'
  //   | 'apoio'
  //   | 'campanha'
  //   | 'campanhapatrocinada'
  //   | 'videopatrocinado'
  //   | 'programete'
  //   // Tipos de Midias
  //   | 'chjorn'
  //   | 'rede'
  //   | 'pgrede'
  //   | 'blocopolitico'
  //   | 'optativo'
  //   // Setores
  //   | 'programacao'
  //   | 'jornalismo'
  //   | 'cedoc'
  //   | 'marketing'
  //   | 'opec'
  //   | 'promo'
  //   | 'hub'
  //   | 'engenharia';
  type: string;
}

export const Container = styled.div<ContainerProps>`
  max-width: 150px;
  padding: 0px 5px;
  height: 26px;
  background-color: ${props =>
    props.theme.flag[props.type] || props.theme.flag.NA};

  opacity: ${props => (props.disabled ? 0.5 : 1)};

  display: flex;
  flex-direction: row !important;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  margin-right: 5px;
  > span {
    padding: 0 0.5rem;
    color: ${props =>
      lighten(0.7, props.theme.flag[props.type] || props.theme.flag.NA)};
    font-weight: 600;
    text-transform: uppercase;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  button {
    margin-left: 5px;
  }
`;
